import React from "react";
import "./CareerValues.scss";

import { ValuesItemData } from "../../data/data";

const CareerValues = () => {
  return (
    <section className="section careerValues">
      <article className="careerValues__container container">
        <div className="careerValues__container--header">
          <h2>Core Values</h2>
          <h3>Values</h3>
        </div>

        <div className="careerValues__container--contents">
          {ValuesItemData.map((item, index) => (
            <div
              key={index}
              className="careerValues__container--contents-items"
            >
              {item.icon}
              <h3 className="contents-items-title">{item.title}</h3>
              <p className="contents-items-text">{item.text}</p>
            </div>
          ))}
        </div>
      </article>
    </section>
  );
};

export default CareerValues;
